import { utils } from "ethers";
import { defaultChainId } from "@/store/bc.store.js";

export default {  
  computed: {  
    gIsDevMode() {
      return process.env.NODE_ENV !== 'production'
    }, 
    gIsMainChain() {
      return this.$bc.chain && this.$bc.chain.symbol === "AVAX"
    } 
    //gDepository() {
    //  return this.$bc.contract("Depository")
    //},
    //gDAI() {
    //  return this.$bc.contract("DAI")
    //},
    //gDLC() {
    //  return this.$bc.contract("DLC")
    //},
    //gWallet() {
    //  return this.$bc.contract("Wallet")
    //},
    //gTreasury() {
    //  return this.$bc.contract("Treasury")
    //},
    //gDLCLiquidityDistributor() {
    //  return this.$bc.contract("DLCLiquidityDistributor")
    //},
    //gDLCDevTeamDistributor() {
    //  return this.$bc.contract("DLCDevTeamDistributor")
    //}, 
  },

  methods: {    
    //gCleanObject: obj => cleanObject(obj),
    async gConnect() {
			await this.$bc.connect();
		},
		async gDisconnect() {
			await this.$bc.disconnect();
		},
    async gSwitchToNetwork(chainId) {
			try {
        if (!chainId) chainId = defaultChainId
        
        console.log('gSwitchToNetwork', parseInt(chainId), utils.hexValue(utils.hexlify(parseInt(chainId))))
				await window.ethereum.request({
					method: "wallet_switchEthereumChain",
					params: [{ chainId: utils.hexValue(utils.hexlify(parseInt(chainId))) }],
				});
			} catch (error) {
				console.log(error);
				this.swalWrongNetwork = this.$swal({
					icon: "error",
					title: "CHEK WALLET",
					confirmButtonText: "OK",
				});
			}
		},
    async gDisconnect() {
			await this.$bc.disconnect();
		},
    async gTimestamp(rpc) {
			const blockNum = await rpc.getBlockNumber();
      const block = await rpc.getBlock(blockNum);
      return block.timestamp;
		},
    

    // Loader
    gLoaderShow({ ...options }) {
      try {
        if (this.$loader) {
          this.$loader.hide()
          this.$loader = null;
        }
        this.isLoading = true;
        options.container = options.container ? options.container : document.querySelector("[loading-container]")
        this.$loader = this.$loading.show(options)
      } catch (error) {
        
      }      
    },

    gLoaderHide(delay = 500) {
      return new Promise(resolve => setTimeout(() => {
        try {
          if (this.$loader) this.$loader.hide()        
          this.$loader = null;
          this.isLoading = false;
        } catch (error) {
          
        }        
        resolve()
      }, delay));
    },

    async gCallMethod({ method, title, loader, emit, callback }) {
      if (loader) {
        this.gLoaderShow({}) 
      }            
      try {
        const tx = await method()             
        if (loader) {
          this.gLoaderHide() 
          await this.gWait(500)            
        }
        
        this.$mitt.emit("tx::swall", { tx, msg: { title }, emit, callback });	
        this.$swal({
          icon: 'success',
          title,
          text: 'Please wait for blockchain confirmation!',
          footer: `<a href="${this.$bc.chain.explorerUrl + 'tx/' + tx.hash}" target="_blank">${this.$filters.txHashShort(tx.hash)}</a>`
        });           
      } catch (error) {
        if (loader) {
          this.gLoaderHide()
          await this.gWait(500)             
        }
        console.log(title, ' error', error)          
        this.$swal({
          icon: 'error',
          title,
          text: error.data?.message ? error.message + ' ' + error.data?.message : error.message,
        });
      }        
    },

    gWait(delay = 500) {
      return new Promise(resolve => setTimeout(() => {        
        resolve()
      }, delay));
    },
    
    gOpenLink(url) {
      console.log(url)
      const { hostname } = new URL(url);
      console.log(hostname, window.location.host)
      if (hostname === window.location.host) return;

      window.open(url, '_blank')
    },

    gAddToMetamask(address, symbol, decimals, img) {
      try {
        ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', 
            options: {
              address, 
              symbol, 
              decimals, 
              image: window.location.origin + img, 
            },
          },
        });          
      } catch (error) {
        console.log(error);
      }
    },
  },
}



//function cleanObject(obj) {
//  return JSON.parse(JSON.stringify(obj))
//}

//export {
//  cleanObject
//}